// eslint-disable-next-line
export var Placement;
(function (Placement) {
    Placement["TOP"] = "top";
    Placement["RIGHT"] = "right";
    Placement["BOTTOM"] = "bottom";
    Placement["LEFT"] = "left";
    Placement["AUTO"] = "auto";
    Placement["CENTER"] = "center";
})(Placement || (Placement = {}));
// eslint-disable-next-line
export var Mode;
(function (Mode) {
    Mode["JS_MODAL"] = "js-modal";
    Mode["RN_MODAL"] = "rn-modal";
    Mode["TOOLTIP"] = "tooltip";
})(Mode || (Mode = {}));
//# sourceMappingURL=Types.js.map